import React, { useState, useEffect } from 'react';
import classes from '../../../styles/games/tic-tac-toe.module.scss';
import {Helmet} from "react-helmet";

type Player = 'X' | 'O' | null;

const WIN_LINES: [number, number, number][] = [
    [0,1,2], [3,4,5], [6,7,8],
    [0,3,6], [1,4,7], [2,5,8],
    [0,4,8], [2,4,6]
];

export default function TicTacToe() {
    const [board, setBoard] = useState<Player[]>(Array(9).fill(null));
    const [current, setCurrent] = useState<Player>('X');
    const [winner, setWinner] = useState<Player | 'Draw' | null>(null);

    // Check winner
    useEffect(() => {
        for (let [a,b,c] of WIN_LINES) {
            if (board[a] && board[a] === board[b] && board[a] === board[c]) {
                setWinner(board[a]);
                return;
            }
        }
        if (board.every(cell => cell !== null)) {
            setWinner('Draw');
        }
    }, [board]);

    const handleClick = (i: number) => {
        if (board[i] || winner) return;
        const next = [...board];
        next[i] = current;
        setBoard(next);
        setCurrent(current === 'X' ? 'O' : 'X');
    };

    const reset = () => {
        setBoard(Array(9).fill(null));
        setCurrent('X');
        setWinner(null);
    };

    return (
        <>
            <Helmet>
                <title>Tic-Tac-Toe</title>
                <meta
                    name="description"
                    content="Play tic-tac-toe with your friends."
                />
            </Helmet>

            <div className={classes.container}>
                <h2 className={classes.title}>Tic‑Tac‑Toe</h2>
                <div className={classes.status}>
                    {winner
                        ? winner === 'Draw'
                            ? <span className={classes.draw}>It's a Draw!</span>
                            : <span className={classes[`player${winner}`]}>Player {winner} Wins!</span>
                        : <span>Next: <span className={classes[`player${current}`]}>{current}</span></span>}
                </div>
                <div className={classes.board}>
                    {board.map((cell, idx) => (
                        <button
                            key={idx}
                            className={classes.cell}
                            onClick={() => handleClick(idx)}
                            disabled={!!cell || !!winner}
                        >
                            {cell}
                        </button>
                    ))}
                </div>
                <button className={classes.reset} onClick={reset}>Reset</button>
            </div>
        </>
    );
}